module.exports = __webpack_public_path__ + "img/unreadMessages.43e43432.svg";